<script setup>
import {computed} from 'vue';
import {Link as InertiaLink} from '@inertiajs/vue3';

const props = defineProps({
    active: Boolean,
    href: {
        type: String,
        default: null,
    },
    as: {
        type: String,
        default: null,
    },
});

const commonCssClasses =
    'block w-full ps-3 pe-4 py-2 border-l-4 text-start text-base font-medium focus:outline-none transition duration-150 ease-in-out ';

const classes = computed(() => {
    return (
        commonCssClasses +
        (props.active
            ? 'border-primary/40 text-primary/70 bg-primary/5 focus:text-primary/80 focus:bg-primary/10 focus:border-primary/70'
            : 'border-transparent text-base-content/60 hover:text-base-content/80 hover:bg-base-content/5 hover:border-base-content/30 focus:text-base-content/80 focus:bg-base-content/5 focus:border-base-content/30')
    );
});
</script>

<template>
    <div>
        <button v-if="as === 'button'" :class="classes" class="w-full text-start">
            <slot />
        </button>

        <a v-else-if="as === 'anchor'" :href="href" :class="classes">
            <slot />
        </a>

        <InertiaLink v-else :href="href" :class="classes">
            <slot />
        </InertiaLink>
    </div>
</template>
